angular.module('mercury.modules.reports.items')
.config(["$stateProvider", function($stateProvider) {
  $stateProvider.state('Reports.ItemsOverview', {
    url: '/items/overview?report',
    templateUrl: 'modules/reports/items/overview.tpl.html',
    controller: 'ReportsItemsOverviewCtrl'
  });

  $stateProvider.state('Reports.ItemsCategories', {
    url: '/items/categories?report',
    templateUrl: 'modules/reports/items/categories.tpl.html',
    controller: 'ReportsItemsCategoriesCtrl'
  });

  $stateProvider.state('Reports.ItemsProducts', {
    url: '/items/products?report&categoryId&categoryName',
    templateUrl: 'modules/reports/items/products.tpl.html',
    controller: 'ReportsItemsProductsCtrl'
  });

  $stateProvider.state('Reports.ItemGroups', {
    url: '/items/groups?report',
    templateUrl: 'modules/reports/items/itemgroups.tpl.html',
    controller: 'ReportsItemGroupsCtrl'
  });
}]);
